'use client';

import { c as _c } from "react/compiler-runtime";
import { PaymentMethods } from 'api-graphql-types/enums';
import { Button, LinkButton, Modal } from 'design-system/client';
import { useLocale, useTranslations } from 'next-intl';
import { useCallback, useState } from 'react';
import styles from './Terms.module.css';
import TextLink from '@/components/TextLink';
import { useDonationFormConfig, useDonationFormValues } from '@/donationPages/_dependencies/helpers';
import { postMessageScrollTop, RailsRoutes } from '@/helpers/utils';
const TermsLink = () => {
  const $ = _c(7);
  const locale = useLocale();
  const t = useTranslations("nextjs.donate.terms");
  let t0;
  if ($[0] !== locale) {
    t0 = RailsRoutes.terms({
      locale
    });
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("terms_label");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <TextLink target="_blank" largerClickArea={true} href={t0} rel="noopener noreferrer">{t1}</TextLink>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const PrivacyLink = () => {
  const $ = _c(7);
  const locale = useLocale();
  const t = useTranslations("nextjs.donate.terms");
  let t0;
  if ($[0] !== locale) {
    t0 = RailsRoutes.privacyPolicy({
      locale
    });
    $[0] = locale;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t) {
    t1 = t("privacy_label");
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <TextLink target="_blank" largerClickArea={true} href={t0} rel="noopener noreferrer">{t1}</TextLink>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
function BetterplaceInfo() {
  const $ = _c(43);
  const t = useTranslations("nextjs");
  const locale = useLocale();
  const {
    channel
  } = useDonationFormConfig();
  const [showModal, setShowModal] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setShowModal(false);
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const hideModal = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowModal(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const openModal = t1;
  const channelPart = channel === "iframe" ? channel : "default";
  const t2 = `donate.terms.${channelPart}_recipient_info`;
  let t3;
  if ($[2] !== t || $[3] !== t2) {
    t3 = t(t2);
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span>{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("donate.terms.default_recipient_name");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <LinkButton onClick={openModal} type="button">{t5}</LinkButton>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <span>(betterplace.org gGmbH)</span>;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("donate.terms.recipient_info_modal_headline");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t) {
    t9 = t("donate.codonation_selection.why_modal.close_button");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t9) {
    t10 = <Button kind="primary" size="small" onClick={hideModal} type="button" className={styles.closeModalButton}>{t9}</Button>;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t) {
    t11 = t("core.close");
    $[18] = t;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("donate.terms.recipient_info_modal_text");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <span>{t12}</span>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <br />;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== locale) {
    t15 = RailsRoutes.aboutUs({
      locale
    });
    $[25] = locale;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t) {
    t16 = t("donate.terms.recipient_info_read_more_label");
    $[27] = t;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t15 || $[30] !== t16) {
    t17 = <TextLink href={t15} target="_blank" rel="noopener noreferrer">{t16}</TextLink>;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== showModal || $[33] !== t10 || $[34] !== t11 || $[35] !== t13 || $[36] !== t17 || $[37] !== t8) {
    t18 = <Modal onClose={hideModal} id="betterplace-info-modal" onOpen={postMessageScrollTop} isOpen={showModal} title={t8} customActions={t10} closeText={t11}>{t13}{t14}{t17}</Modal>;
    $[32] = showModal;
    $[33] = t10;
    $[34] = t11;
    $[35] = t13;
    $[36] = t17;
    $[37] = t8;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== t18 || $[40] !== t4 || $[41] !== t6) {
    t19 = <>{" "}{t4}{" "}{t6}{" "}{t7}{t18}</>;
    $[39] = t18;
    $[40] = t4;
    $[41] = t6;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  return t19;
}
function SEPAMandateLink() {
  const $ = _c(31);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["payment_method"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [paymentMethod] = useDonationFormValues(t0);
  const [showModal, setShowModal] = useState(false);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowModal(false);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hideModal = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setShowModal(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const openModal = t2;
  const t = useTranslations("nextjs");
  if (paymentMethod !== PaymentMethods.StripeSepaDebit) {
    return null;
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("donate.terms.sepa_prefix");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span>{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t("donate.terms.sepa_mandate_label");
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <LinkButton onClick={openModal} type="button">{t5}</LinkButton>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t) {
    t7 = t("donate.terms.sepa_mandate_label");
    $[11] = t;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("donate.codonation_selection.why_modal.close_button");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Button kind="primary" size="small" onClick={hideModal} type="button" className={styles.closeModalButton}>{t8}</Button>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("core.close");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t) {
    t11 = t("donate.terms.sepa_mandate_stripe_disclaimer");
    $[19] = t;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== showModal || $[22] !== t10 || $[23] !== t11 || $[24] !== t7 || $[25] !== t9) {
    t12 = <Modal onClose={hideModal} onOpen={postMessageScrollTop} isOpen={showModal} title={t7} customActions={t9} closeText={t10}>{t11}</Modal>;
    $[21] = showModal;
    $[22] = t10;
    $[23] = t11;
    $[24] = t7;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4 || $[29] !== t6) {
    t13 = <>{" "}{t4}{" "}{t6}{t12}</>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t6;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
export default function Terms() {
  const $ = _c(20);
  const t = useTranslations("nextjs.donate.terms");
  let t0;
  if ($[0] !== t) {
    t0 = t("terms_link_prefix");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <span>{t0}</span>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TermsLink />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("privacy_link_prefix");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <span>{t3}</span>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <PrivacyLink />;
    t6 = <BetterplaceInfo />;
    t7 = <SEPAMandateLink />;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t) {
    t8 = t("terms_suffix");
    $[12] = t;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t8) {
    t9 = <span>{t8}</span>;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t1 || $[17] !== t4 || $[18] !== t9) {
    t10 = <div className={styles.termsOfUseContainer}>{t1}{t2}{t4}{t5}{t6}{t7}{t9}</div>;
    $[16] = t1;
    $[17] = t4;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  return t10;
}